import * as React from 'react';
import { ContractsScreen } from '../components/contracts.js';

/**
 * `/smlouvy` — PREHLED smluv napric zakazkami (krok UXS1 bod 1).
 *
 * Stranka uz nema vlastni nadpis ani perex: hlavicku (nadpis + „+ Nová
 * smlouva") nese `ContractsScreen`, aby nadpis nebyl trikrat pod sebou
 * („Smlouvy" / „Smlouvy zakázky" / „Smlouvy zakázky" — nalez R.B. 1. 10.).
 * Editor je vlastni adresa `/smlouvy/:id`.
 *
 * Krok UXR2 (zadani bod 5): obsah se nemeni, jen hlavicka jde do shellu
 * (`pageHead`) — nadpis obrazovky je tak na mobilu v horni liste a „+ Nová
 * smlouva" v plovouci liste, stejne jako na ostatnich obrazovkach.
 */
export function SmlouvyPage(): React.JSX.Element {
  return (
    <div data-testid="smlouvy-page">
      <div className="rh-a2-page rh-a2-page--wide">
        <ContractsScreen pageHead />
      </div>
    </div>
  );
}
